<template>
  <div class="chart_dialog" ref="dialog">
   <div>
     <span class="title">在线统计</span>
     <div ref="chart" class="chart"></div>
   </div>
   <div v-if="hasAlarm">
     <span class="title">{{deviceType === '1004' ? "流压" : ''}}告警统计</span>
     <div class="alarm">
       <div v-for="(item, index) in alarm" :key="index">
         <span class="dot" :style="{ background: item.color }"></span>
         <span>{{item.name}}</span>
         <span class="value">{{item.value || 0}}</span>
       </div>
     </div>
   </div>
 </div>
 </template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
import { deviceTypeList } from './mapIcon'
export default {
  name: 'ChartDialog',
  data () {
    return {
      sum: 0,
      alarm: [{
        name: '正常',
        value: 0,
        color: '#628DF6'
      }, {
        name: '告警',
        value: 0,
        color: '#E22828'
      }]
    }
  },
  computed: {
    projectId () {
      return this.$route.query.projectId
    },
    deviceType () {
      return this.$route.query.deviceType
    },
    hasAlarm () {
      return ['1001', '1011', '1004'].includes(this.deviceType)
    },
    theme () {
      return this.$store.state.theme
    }
  },
  watch: {
    projectId (val) {
      if (val) {
        this._chart && this._chart.dispose()
      }
      this.loadData()
    },
    $route (to) {
      if (to.path === '/deviceMap' && this.deviceType) {
        this.loadData()
      }
    },
    theme () {
      this.setTheme()
    }
  },
  created () {
    this.loadData()
  },
  destroyed () {
    this._chart && this._chart.dispose()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.iot.selectDeviceOnlineStats, {
        projectId: this.projectId,
        objectType: this.deviceType === '1004' ? deviceTypeList.get(this.deviceType) + ',' + deviceTypeList.get('1014') + ',' + deviceTypeList.get('liuya'): deviceTypeList.get(this.deviceType)
      }).then(res => {
        this.refreshEchart(res)
      })
    },
    // 重新绘制
    refreshEchart (res) {
      this._chart && this._chart.clear()
      this.$nextTick(() => {
        this.renderPie(res)
      })
      if (this.hasAlarm) {
        this.alarm[0].value = res.runStatusOnline
        this.alarm[1].value = res.runStatusOffline
      }
    },
    renderPie (res) {
      const color = ['#628DF6', '#89F3F7', '#FEE186']
      const title = {
        name: '在线率',
        per: res.onlineRate
      }
      const data = [{
        name: '总数',
        value: res.total || 0
      },
      {
        name: '在线',
        value: res.totalOnline || 0
      },
      {
        name: '离线',
        value: res.totalOffline || 0
      }]
      setTimeout(() => {
        this.renderChart(data, color, title)
      }, 500)
    },
    renderChart (data, color, title) {
      this._chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          show: false,
          formatter: '{a} <br/>{b}: {d}%',
          textStyle: {
            fontSize: px2vw(12)
          }
        },
        title: {
          show: title.name,
          text: title.per,
          subtext: title.name,
          left: '18%',
          textAlign: 'center',
          top: px2vw(20),
          textStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            fontFamily: 'PingFangSC, PingFang SC'
          },
          subtextStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            lineHeight: 0,
            fontFamily: 'PingFangSC, PingFang SC'
          }
        },
        legend: {
          orient: 'vertical',
          top: 'center',
          left: '51%',
          icon: 'circle',
          itemWidth: px2vw(6),
          formatter: (name) => {
            const index = data.findIndex((item) => item.name === name)
            const arr = '{a|' + name + '}{b|' + data[index].value + '}'
            return arr
          },
          textStyle: {
            fontSize: px2vw(14),
            color: '#000000',
            align: 'center',
            rich: {
              a: {
                padding: [0, 0, 0, px2vw(2)]
              },
              b: {
                padding: [px2vw(15), 0, px2vw(15), px2vw(28)]
              }
            }
          }
        },
        color: color,
        series: [
          {
            // avoidLabelOverlap: false,
            hoverOffset: 0,
            type: 'pie',
            radius: ['90%', '100%'],
            center: ['20%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            zlevel: 4,
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 1)',
                borderWidth: 0,
                color: (value) => {
                  return color[value.dataIndex]
                }
                // shadowColor: 'rgba(0,0,0,0.4)',
                // shadowBlur: 10
              }
            },
            data: data,
            labelLine: {
              show: false
            }
          },
          {
            labelLine: {
              show: false
            },
            itemStyle: {
              opacity: 0.2,
              borderColor: '#ffffff',
              borderWidth: 2
            },
            type: 'pie',
            hoverAnimation: false,
            radius: ['70%', '90%'],
            center: ['20%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: data,
            zlevel: -1
          }
        ]
      }
      this._chart.clear()
      this._chart.setOption(option)
      this.setTheme()
    },
    setTheme () {
      const style = window.getComputedStyle(this.$refs.dialog)
      const color = style.getPropertyValue('--header-bar-title-color').trim()
      this._chart && this._chart.setOption({
        title: {
          textStyle: {
            color: color
          },
          subtextStyle: {
            color: color
          }
        },
        legend: {
          textStyle: {
            color: color
          }
        }
      })
    }
  }
}
</script>

 <style scoped lang='scss'>
 .chart_dialog{
  position: absolute;
  top: 90px;
  left: 40px;
  z-index: 909;
  width: 250px;
  min-height: 173px;
  background: var(--map-popup-bg);
  color: var(--header-bar-title-color);
  box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
  border-radius: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  >div{
    &:last-of-type{
      border-bottom: 0;
    }
    >div{
      padding: 20px 0px 20px 20px;
      &.chart{
        height: 77px;
        box-sizing: content-box;
      }
      &.alarm{
        display: flex;
        >div{
          flex: 1;
          .dot{
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 6px;
          }

          .value{
            display: inline-block;
            margin-left: 30px;
          }
        }
        span{
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 12px;
          color: var(--header-bar-title-color);
          line-height: 16px;
          text-align: left;
          font-style: normal;
        }
      }
    }
  }

  .title{
    display: inline-block;
    width: 100%;
    height: 33px;
    line-height: 33px;
    padding-left: 19px;
    border-bottom: 1px solid var(--right-bg-tab);
  }
 }
 </style>
